import React, { useMemo } from "react";
import "./GenOverView.css";
import { Grid } from "@mui/material";

import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import CustomizeTootip from "../../components/CustomizeTootip";

import GraphLoader from "../../components/GraphLoader";

const ActualPRAcAndDcCUFContainer = ({ loading, acLineLossActualPr }) => {
  const acLineLossMinMaxRange = useMemo(() => {
    if (acLineLossActualPr?.length > 0) {
      const plantAvailabilitydocLen = acLineLossActualPr?.reduce(
        (acc, curr) =>
          acc +
          (!isNaN(curr?.["Plant Availability"]) && curr?.["Plant Availability"] > 0
            ? 1
            : 0),
        0
      );
      const actualPRdocLen = acLineLossActualPr?.reduce(
        (acc, curr) =>
          acc + (!isNaN(curr?.["Actual Pr"]) && curr?.["Actual Pr"] > 0 ? 1 : 0),
        0
      );

      const acCUFLen = acLineLossActualPr?.reduce(
        (acc, curr) =>
          acc + (!isNaN(curr?.["AC CUF"]) && curr?.["AC CUF"] > 0 ? 1 : 0),
        0
      );

      const dcCUFLen = acLineLossActualPr?.reduce(
        (acc, curr) =>
          acc + (!isNaN(curr?.["DC CUF"]) && curr?.["DC CUF"] > 0 ? 1 : 0),
        0
      );

      return {
        min: Math.floor(
          acLineLossActualPr?.reduce(
            (acc, curr, index) => Math.min(curr?.["Plant Availability"], acc),
            Infinity
          )
        ),
        max: Math.ceil(
          acLineLossActualPr?.reduce(
            (acc, curr, index) => Math.max(curr?.["Plant Availability"], acc),
            -Infinity
          )
        ),

        plantAvailability:
          plantAvailabilitydocLen > 0
            ? Number(
                Number(
                  acLineLossActualPr?.reduce(
                    (acc, curr) =>
                      acc + Number(curr?.["Plant Availability"] || 0),
                    0
                  ) / plantAvailabilitydocLen
                ).toFixed(2)
              )
            : 0,

        actualPR:
          actualPRdocLen > 0
            ? Number(
                acLineLossActualPr?.reduce(
                  (acc, curr) => acc + Number(curr?.["Actual Pr"] || 0),
                  0
                ) / actualPRdocLen
              ).toFixed(2)
            : 0,
        acCUF:
          acCUFLen > 0
            ? Number(
                acLineLossActualPr?.reduce(
                  (acc, curr) => acc + Number(curr?.["AC CUF"] || 0),
                  0
                ) / acCUFLen
              ).toFixed(2)
            : 0,
        dcCUF:
          dcCUFLen > 0
            ? Number(
                acLineLossActualPr?.reduce(
                  (acc, curr) => acc + Number(curr?.["DC CUF"] || 0),
                  0
                ) / dcCUFLen
              ).toFixed(2)
            : 0,
      };
    }

    return { plantAvailability: 0, actualPR: 0 };
  }, [acLineLossActualPr]);

  return loading ? (
    <Grid
      item
      // lg={3.5}
      // md={6}
      // sm={6}
      // xs={12}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        minHeight:"30vh"
      }}
    >
      <GraphLoader />
    </Grid>
  ) : !acLineLossActualPr || acLineLossActualPr?.length == 0 ? (
    <Grid
      item
      // lg={3.5}
      // md={6}
      // sm={6}
      // xs={12}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        minHeight:"30vh"
      }}
    >
      <div style={{ width: "100%", fontSize: "2vmin" }}>
        <p>Ac Line Loss and Actual PR</p>
        <p>Data Not Available</p>
      </div>
    </Grid>
  ) : (
    <Grid
      //  sx={{borderLeft:"0.5vmax solid rgb(3, 99, 125)",borderRight:"0.5vmax solid rgb(3, 99, 125)"}}
      item
      // lg={3.5} md={6} sm={6} xs={12}
      className="gen-overview-2"
    >
      <ResponsiveContainer width="100%" >
        <AreaChart
          margin={{
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          }}
          
          data={
            acLineLossActualPr?.map((e) => ({
              ...e,
              "Actual PR": e?.["Actual Pr"],
            })) || []
          }
        >
          <XAxis
            dataKey="Date"
            fontSize="0.5rem"
            fontWeight={600}
            tickLine={false}
            tickMargin={0}
            angle={-35}
            textAnchor="end"
          />

          <YAxis type="number" yAxisId="bar1" hide />
          <YAxis type="number" yAxisId="bar2" hide />
          <Area
            dataKey="Actual PR"
            yAxisId="bar1"
            stroke="rgb(11, 165, 119)"
            strokeWidth={0.2}
            fill="rgb(20, 213, 149)"
          />

          <Area
            dataKey="Plant Availability"
            yAxisId="bar2"
            stroke="rgb(11, 165, 119)"
            strokeWidth={0.2}
            fill="rgb(91, 248, 201)"
          />
          <Area
            dataKey="AC CUF"
            yAxisId="bar1"
            stroke="rgb(11, 110, 100)"
            strokeWidth={0.2}
            fill="rgb(10, 190, 129)"
          />

          <Area
            dataKey="DC CUF"
            yAxisId="bar1"
            stroke="rgb(1, 100, 90)"
            strokeWidth={0.2}
            fill="rgb(10, 190, 129)"
          />
          <Tooltip
            content={
              <CustomizeTootip
                active={false}
                payload={[]}
                label={""}
                TooltipValues={[
                  "Actual PR",
                  "Plant Availability",
                  "AC CUF",
                  "DC CUF",
                ]}
              />
            }
          />
        </AreaChart>
      </ResponsiveContainer>
      <div>
        <div>
          <span>
            {acLineLossMinMaxRange.actualPR
              ? acLineLossMinMaxRange.actualPR
              : "N/A"}
          </span>
          <span>
            Actual PR <p>(%)</p>{" "}
          </span>
        </div>
        <span
          style={{
            width: "2px",
            background: "rgb(166, 176, 173)",
            height: "90%",
          }}
        ></span>
        <div>
          <span>
            {acLineLossMinMaxRange.plantAvailability
              ? acLineLossMinMaxRange.plantAvailability
              : "N/A"}
          </span>
          <span>
            Plant Availability <p>(%)</p>{" "}
          </span>
        </div>
        <span
          style={{
            width: "2px",
            background: "rgb(166, 176, 173)",
            height: "90%",
          }}
        ></span>
        <div>
          <span>
            {acLineLossMinMaxRange.acCUF ? acLineLossMinMaxRange.acCUF : "N/A"}
          </span>
          <span>
            AC CUF <p>(%)</p>{" "}
          </span>
        </div>

        <span
          style={{
            width: "2px",
            background: "rgb(166, 176, 173)",
            height: "90%",
          }}
        ></span>
        <div>
          <span>
            {acLineLossMinMaxRange.dcCUF ? acLineLossMinMaxRange.dcCUF : "N/A"}
          </span>
          <span>
            DC CUF <p>(%)</p>{" "}
          </span>
        </div>
      </div>
    </Grid>
  );
};

export default ActualPRAcAndDcCUFContainer;
